














































import { Component, Mixins } from 'vue-property-decorator';
import Modal from './slugs.modal.vue';
import TableMixin from '@/mixins/table.mixin';

@Component({
  components: { Modal },
})
export default class UserRolesShell extends Mixins(TableMixin) {
  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    {
      label: 'WEB_MANAGEMENT.SLUGS.TYPE',
      name: 'type',
      sortable: true,
      style: 'width:1px',
      field: (row: any) => this.$t(`WEB_MANAGEMENT.SLUGS.TYPES.${row.type}`),
    },
    {
      label: 'WEB_MANAGEMENT.SLUGS.HREF',
      name: 'href',
      sortable: true,
      field: (row: any) => `/${row.href}`,
    },
    { label: 'GENERAL.EDIT', name: 'actions', align: 'center' },
  ];

  filters = [
    {
      label: this.$i18n.t('GENERAL.STATUS'),
      type: 'select',
      value: [],
      fieldName: 'isActive',
      useChips: true,
      multiple: true,

      options: [
        { label: this.$i18n.t('GENERAL.ACTIVE'), value: true },
        { label: this.$i18n.t('GENERAL.PASSIVE'), value: false },
      ],
    },
    {
      label: this.$i18n.t('WEB_MANAGEMENT.SLUGS.TYPE'),
      type: 'select',
      value: [],
      useChips: true,
      multiple: true,
      fieldName: 'type',
      options: [
        { label: this.$i18n.t('WEB_MANAGEMENT.SLUGS.TYPES.STATIC'), value: 'STATIC' },
        { label: this.$i18n.t('WEB_MANAGEMENT.SLUGS.TYPES.LIST'), value: 'LIST' },
        { label: this.$i18n.t('WEB_MANAGEMENT.SLUGS.TYPES.SINGLE'), value: 'SINGLE' },
      ],
    },
    { label: this.$i18n.t('WEB_MANAGEMENT.SLUGS.HREF'), type: 'text', value: '', fieldName: 'href' },
  ];
}
